import { CategoriesTree, ITreeAsCategories } from "types/articles";

export function buildCategoryTree(data: ITreeAsCategories): CategoriesTree[] {
  const categories = data.pages.treeAsCategories;
  const rootCategories: CategoriesTree[] = [];
  const categoryLookup = {};

  // always excluding depth: 1 because it's the product itself
  categories
    .filter((category) => category.depth > 1)
    .forEach((category) => {
      categoryLookup[category.id] = { ...category, children: [] };
    });

  categories
    .filter((category) => category.depth > 1)
    .forEach((category) => {
      if (category.depth === 2) {
        rootCategories.push(categoryLookup[category.id]);
      } else {
        categoryLookup[category.parent]?.children.push(
          categoryLookup[category.id]
        );
      }
    });

  return rootCategories;
}
